$(document).ready(function() {
    $('.single-preslide')
        .delay(1500)
        .queue(function (next) {
            $(this).css('opacity', '0');
            next();
        });

    $('.single-preslide')
        .delay(3000)
        .queue(function (next2) {
            $(this).css('display', 'none');
            next2();
        });
});


